var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12385 3.75621C8.02906 0.970261 11.9704 0.970261 12.8756 3.75621C13.2805 5.00213 14.4415 5.84567 15.7515 5.84567C18.6809 5.84567 19.8988 9.59414 17.5289 11.316C16.4691 12.086 16.0256 13.4509 16.4305 14.6968C17.3357 17.4827 14.147 19.7994 11.7772 18.0776C10.7173 17.3076 9.28219 17.3076 8.22235 18.0776C5.85248 19.7994 2.66384 17.4827 3.56905 14.6968C3.97387 13.4509 3.53039 12.086 2.47055 11.316C0.100683 9.59414 1.31864 5.84567 4.24796 5.84567C5.55799 5.84567 6.71903 5.00213 7.12385 3.75621Z",
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGrey);
export default __webpack_public_path__ + "static/media/star-grey.54a46259d662d75a0422eed417472744.svg";
export { ForwardRef as ReactComponent };